import React, { useEffect, useState } from 'react'
import './my-progress.css'
import { Button, Modal } from "react-bootstrap";
import '../../modals/common-modal/successfull_modal/Successfull_Modal.css'
import My_progress_lottie from '../../../animation/my-progress/My_progress_lottie';
import { useDispatch, useSelector } from 'react-redux';
import { myAccount, myEventRegistration } from '../../../../features/my_account/Slice';

const My_progress = (props) => {

    const dispatch = useDispatch();

    const registrations = useSelector((state) => state.myaccount.event_registrations);

    useEffect(() => {
        dispatch(myEventRegistration());
    }, [dispatch]);

    const user = useSelector((state) => state.myaccount.addMyaccount);

    useEffect(() => {
        dispatch(myAccount());
    }, [dispatch]);

    return (
        <>
            <Modal
                className="Successfull_Modal my_progress_modal"
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>{props.headtext}
                    <img onClick={props.onHide} className='close_icon' src={process.env.PUBLIC_URL + '/assets/images/icons/close.png'} />
                </Modal.Header>
                <Modal.Body>

                    <div className='row'>
                        <div className='col-md-10 mx-auto'>
                            <p className="top_text">Congratulations on Completing  {user?.level_name || "Level 1"} of Your Journey to Divinity!</p>

                            <div className='row mt-4' >
                                {
                                    registrations?.data?.map((event) => (
                                        <div className='col-sm-6 mb-3'>
                                            {
                                                event?.is_completed ?
                                                    <div className='shibir_div'>
                                                        <p className='shibname'>{event?.Event?.name || "pp"}</p>
                                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                                    </div> :
                                                    <div className='shibir_div2'>
                                                        <p className='shibname'>{event?.Event?.name || "pp"}</p>
                                                    </div>
                                            }

                                        </div>
                                    ))
                                }
                                {/* <div className='col-sm-6 mb-3'>
                                    <div className='shibir_div'>
                                        <p className='shibname'>Prarambhik Shibir</p>
                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                    </div>
                                </div>
                                <div className='col-sm-6 mb-3'>
                                    <div className='shibir_div'>
                                        <p className='shibname'>Prarambhik Shibir</p>
                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                    </div>
                                </div>
                                <div className='col-sm-4 mb-3'>
                                    <div className='shibir_div2'>
                                        <p className='shibname'>Prarambhik Shibir</p>
                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                    </div>
                                </div>
                                <div className='col-sm-4 mb-3'>
                                    <div className='shibir_div2'>
                                        <p className='shibname'>Prarambhik Shibir</p>
                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                    </div>
                                </div>
                                <div className='col-sm-4 mb-3'>
                                    <div className='shibir_div2'>
                                        <p className='shibname'>Prarambhik Shibir</p>
                                        <p className='shibstatus zoom_in_out'>Completed</p>
                                    </div>
                                </div>

                                <div className='col-sm-8 mb-3 mx-auto'>
                                    <div className='shibir_div2'>
                                        <p className='shibname'>Divyadrishti Midbrain Activation Shibir (Under 18 Only)</p>
                                    </div>
                                </div> */}
                            </div>


                            <div className="lottie_holder">
                                <My_progress_lottie />
                            </div>

                            {/* <div className='row'>
                                <div className='col-md-4 col-7 mx-auto'>
                                    <img className='progressimg' src={process.env.PUBLIC_URL + '/assets/images/icons/progress.png'} />
                                </div>
                            </div> */}
                        </div>
                    </div>



                </Modal.Body>
            </Modal>
        </>
    )
}

export default My_progress